import { render, staticRenderFns } from "./jsonInput.vue?vue&type=template&id=5da73e22&scoped=true&"
import script from "./jsonInput.vue?vue&type=script&lang=js&"
export * from "./jsonInput.vue?vue&type=script&lang=js&"
import style0 from "./jsonInput.vue?vue&type=style&index=0&id=5da73e22&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da73e22",
  null
  
)

export default component.exports